/**
 * Lifted verbatim from `PostMediaManager.tsx` so both the render branch and
 * the video-slot popover (Task 12b) share one "is this slot a video" answer —
 * previously the regex only lived inside the component, so a second module
 * that needed the same decision would have had to import the component (the
 * exact cycle a lift like this avoids) or duplicate the regex and risk drift.
 *
 * Copied byte-for-byte in the lift commit (do not "improve" the regex in the
 * same change that moves it — a behaviour change hiding inside a refactor is
 * hard to review and hard to revert independently).
 */
const VIDEO_RE = /\.(mp4|mov|webm)(\?|$)/i;

export const isVideoUrl = (url: string): boolean => VIDEO_RE.test(url);
